<div class="punchlists">

  <p-accordion *ngFor="let checkList of checkLists" [activeIndex]="hideAccord(checkList)">
    <p-accordionTab>
      <p-header>
        <div class="checklist-header">
          <div class="list-title">{{checkList.name}}</div>
          <div class="punch-counter">{{countPunchlist(checkList)}}</div>
          <div class="toggle-delete" (click)="toggleDeleteChecklist($event, checkList)">
            <span *ngIf="deleteChecklistIds.includes(checkList.id)">close</span>
            <span *ngIf="!deleteChecklistIds.includes(checkList.id)">edit</span>
          </div>
        </div>

        <!-- <div class="right-button-block">
          <button class="preview-button" mat-button (click)="openPdfPreview()">Print
            Preview</button>
        </div> -->
      </p-header>
      <div class="punchlist-row-block" cdkDropList (cdkDropListDropped)="checkListDropped($event, checkList)">
        <div class="punchlist-row" *ngFor="let checkItem of checkList?.checkItems"
             [ngClass]="{'collapsed-content': checkItem.collapsed, 'can-be-collapsed': checkItem.taskDto?.checkitemsCompleted >= checkItem.taskDto?.checkitemsTotal}">
          <ng-container *ngIf="checkItem.taskDto">
            <app-task-card [id]="checkItem.taskDto.id" [task]="checkItem.taskDto" [fromProj]="true" [showFrom]="true"
                           [toggleOrders]="toggleOrders" [workOrder]="checkItem.workOrder"
                           [projectTask]="true"
                           [isCollapsed]="checkItem.collapsed"
                           (click)="editTask($event, checkItem)" (emitCollapseOff)="emitCollapseOff($event)"
                           (workOrderToggle)="toggleWorkOrderForTask($event, checkItem)"
                           (collapseToggle)="toggleCollapse(checkItem)">
            </app-task-card>
          </ng-container>

          <ng-container *ngIf="!checkItem.taskDto">

            <div class="check-item-row" *ngIf="!(editItem === checkItem.id)" cdkDrag
                 [class.checked-checkitem]="checkItem.ready" (cdkDragStarted)="stopDrag()">
              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>

              <div class="punch-item-block">
                <div class="handle-icon" cdkDragHandle
                     [ngClass]="{'hide-handle' : !deleteChecklistIds.includes(checkList.id)}">
                  <i class="pi pi-bars"></i>
                </div>

                <div class="order-icon" (click)="toggleWorkOrder(checkItem)"
                     *ngIf="checkList.name === 'Punch List Items' && toggleOrders"
                     [class.checked-order]="checkItem.workOrder">
                  <mat-icon *ngIf="!checkItem.workOrder">check_box_outline_blank</mat-icon>
                  <mat-icon *ngIf="checkItem.workOrder">check_box</mat-icon>
                </div>

                <div class="check-icon" (click)="toggleReady(checkItem)">
                  <mat-icon>done</mat-icon>
                </div>
                <div class="punchlist-checkitem-title-tags" (click)="editCheckItem(checkList.id, checkItem.id)">
                  <div class="punchlist-checkitem-title">
										<span appUserMentionContent [content]="checkItem.name"
                          [mentions]="checkItem.mentions" class="pre-wrap">
										</span>
                    <div *ngIf="loadingSpinnerId === checkItem.id" class="loading-block-spinner">
                      <mat-spinner></mat-spinner>
                    </div>

                    <app-check-item-icons [checkItem]="checkItem" [projectId]="projectId"></app-check-item-icons>

                  </div>

                  <div class="punchlist-tags" *ngIf="checkItem.tags?.length > 0">
                    <div class="punchlist-tag {{tag?.type?.title}}-tag"
                         *ngFor="let tag of checkItem.tags" (click)="toggleTag($event, tag)"
                         [ngClass]="{'ready-tag': tag.ready, 'sent-tag': tag.sentDate, 'missed-tag': tag.name === 'Amount' && !tag.invoiceId}">
											<span class="tag-span">
                        {{tag?.type?.title}}
                        <span *ngIf="tag.name === 'Amount'">
													<span *ngIf="!tag.sentDate && !tag.ready"> - Not Sent</span>
													<span *ngIf="tag.sentDate && !tag.ready"> - Not Paid</span>
													<span *ngIf="!tag.invoiceId && !tag.ready"> - Missing</span>
													<span *ngIf="tag.ready"> - Paid</span>
												</span>
											</span>
                    </div>
                  </div>
                </div>

                <div class="check-delete-block" (click)="deleteCheckItem(checkItem, checkList)"
                     *ngIf="deleteChecklistIds.includes(checkList.id)">
                  <div class="check-icon delete-check-icon"
                       *ngIf="!idsToDelete.includes(checkItem.id)">
                    <mat-icon>delete</mat-icon>
                  </div>
                  <div *ngIf="idsToDelete.includes(checkItem.id)"
                       class="delete-loading-block-spinner">
                    <mat-spinner></mat-spinner>
                  </div>
                </div>
              </div>
            </div>

            <div class="edit-punch-item-block" *ngIf="editItem === checkItem.id">
              <app-edit-punch-item [checkItem]="checkItem"
                                   (updateAction)="onUpdateItem($event, checkList)"
                                   (deleteAction)="deleteCheckItem(checkItem, checkList)"
                                   (closeAction)="onEditBlockClosed()" [users]="users" [tags]="tags">
              </app-edit-punch-item>
            </div>

          </ng-container>

        </div>
      </div>

      <div class="new-punch-item-block">
        <div class="buttons-checklist-block">
          <button mat-button class="show-input-button" (click)="addCheckItem(checkList)"
                  *ngIf="editItem !== -2 || checkListForAdd !== checkList.id">
            <mat-icon>add</mat-icon>
            <div class="button-title">Add new check item</div>
          </button>


          <ng-container *ngIf="checkListForAdd !== checkList.id && checkList.name === 'Punch List Items'">

            <button mat-button class="show-input-button work-order-button" (click)="createWorkOrder()"
                    *ngIf="toggleOrders && idsToOrder.length > 0">
            <span class="button-title">
            <span class="order-span" style="font-weight: bold">({{idsToOrder.length}})</span>  Create Order
            </span>
            </button>

            <button mat-button class="show-input-button work-order-button" (click)="addToOrder()"
                    *ngIf="toggleOrders && idsToOrder.length > 0">
            <span class="button-title">
            <span class="order-span" style="font-weight: bold">({{idsToOrder.length}})</span> Add to order
            </span>
            </button>

            <button mat-button class="show-input-button work-order-button" (click)="toggleWorkOrders()">
              <span class="button-title" *ngIf="!toggleOrders">Service Order</span>
              <span class="button-title" *ngIf="toggleOrders">Cancel</span>
            </button>
          </ng-container>
        </div>

        <app-add-punch-item [checkList]="checkList" (closeAction)="onEditBlockClosed()" [users]="users"
                            [tags]="tags" *ngIf="editItem === -2 && checkListForAdd === checkList.id">
        </app-add-punch-item>
      </div>
    </p-accordionTab>
  </p-accordion>

  <input class="mobile-photo-input" type="file" capture="camera" id="cameraInput" name="cameraInput"
         (change)="onFileSelected($event)">
</div>
